// extracted by mini-css-extract-plugin
module.exports = {"sharingBox":"style_sharingBox__1gUNK","sharingButton":"style_sharingButton__3Q3ui"};